<template>
    <div>
        <v-row>
            <v-col cols="12">
                <v-card>
                    <v-card-title>
                        ورود سند حمل و نقل
                    </v-card-title>
                    <form>
                        <v-card-text style="padding-top: 0px">
                            <v-row>
                                <v-col cols="2">
                                    <v-row form class="form-group">
                                        <label>
                                            شماره بارنامه
                                        </label>
                                        <div dir="rtl">
                                            <v-text-field
                                                    v-model="model.tozin_number"
                                                    id="barname"
                                                    outlined

                                                    :error-messages="barname_description"
                                                    @keypress="isNumber"
                                                    dense
                                                    v-on:keyup.enter="barname_next_focus()"
                                                    label=""/>
                                            <!--                                            <label style="text-align: right;color: red">{{barname_description}}</label>-->
                                        </div>
                                    </v-row>
                                </v-col>
                                <v-col cols="1">
                                    <v-row form class="form-group">
                                        <label>

                                        </label>
                                        <div dir="rtl">
                                            <br>
                                            <v-btn v-if="barname_exist" small id="info_exist_barname" color="primary"
                                                   @click="docInfoModal=true">
                                                <v-icon>mdi-eye</v-icon>
                                            </v-btn>
                                        </div>
                                    </v-row>
                                </v-col>
                                <v-col cols="3" v-show="false">
                                    <v-row form class="form-group">
                                        <label>
                                            تاریخ سند
                                        </label>
                                        <div dir="rtl" style="margin-top: 20px;" v-on:keyup.enter="focusNext($event)">
                                            <date-picker
                                                    editable
                                                    v-mask="'####/##/##'"
                                                    id="doc_date"
                                                    :auto-submit="true"
                                                    v-model="model.doc_date"
                                                    display-format="jYYYY/jMM/jDD"
                                                    format="jYYYY/jMM/jDD"
                                            ></date-picker>
                                        </div>
                                    </v-row>

                                </v-col>
                                <v-col cols="3">
                                    <v-row form class="form-group">
                                        <label>
                                            تاریخ سند
                                        </label>
                                        <v-row dir="rtl" style="margin-right: 20px;"
                                               v-on:keyup.enter="focusNext($event)">
                                            <v-col cols="3" style="padding-top:0px;padding-right: 0px">
                                                <v-text-field
                                                        v-model="date_day"
                                                        @keypress="isNumber"
                                                        dense
                                                        outlined
                                                        id="date_day"
                                                        v-on:keyup.enter="another_focus_select('date_month')"
                                                />
                                            </v-col>
                                            <v-col cols="3" style="padding-top:0px;padding-right: 0px">
                                                <v-text-field
                                                        v-model="date_month"
                                                        @keypress="isNumber"
                                                        dense
                                                        outlined
                                                        id="date_month"
                                                        v-on:keyup.enter="focusNext($event)"

                                                />
                                                <!--                                                v-on:keyup.enter="another_focus_select('date_year')"-->

                                            </v-col>
                                            <v-col cols="3" style="padding-top:0px;padding-right: 0px">
                                                <div class="v-input v-input--is-label-active v-input--is-dirty v-input--dense theme--light v-text-field v-text-field--is-booted v-text-field--enclosed v-text-field--outlined">
                                                    <div class="v-input__control">
                                                        <div class="v-input__slot">
<!--                                                            <fieldset aria-hidden="true">-->
<!--                                                                <legend style="width: 0px;">-->
<!--                                                                    <span></span>-->
<!--                                                                </legend>-->
<!--                                                            </fieldset>-->
                                                            <div class="v-text-field__slot">
                                                                <label
                                                                        disabled
                                                                        class="border-dark"
                                                                        @keypress="isNumber"
                                                                        id="date_year"
                                                                        style="    border: 1px solid rgba(0, 0, 0, 0.42);padding: 9px;border-radius: 3px;"
                                                                        v-on:keyup.enter="focusNext($event)"
                                                                >{{date_year}}</label>
                                                            </div>
                                                        </div>
                                                        <div class="v-text-field__details">
                                                            <div class="v-messages theme--light">
                                                                <div class="v-messages__wrapper"></div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </v-col>
                                        </v-row>
                                    </v-row>

                                </v-col>
                                <v-col cols="3">
                                    <v-row form class="form-group">
                                        <label>
                                            کامیون
                                        </label>
                                        <div dir="rtl">
                                            <treeselect
                                                    :matchKeys="['code']"
                                                    v-model="model.selected_truck"
                                                    :cacheOptions="false"
                                                    :options="trucks"
                                                    :disableBranchNodes="false"
                                                    @select="another_focus_inside('load_type')"
                                                    placeholder="جستجو کامیون"
                                                    :normalizer="normalizer_truck"
                                            />
                                        </div>
                                    </v-row>

                                </v-col>
                                <v-col cols="3"></v-col>

                            </v-row>
                            <hr>
                            <v-row>
                                <label>سقف تناژ قابل حمل</label>
                                <v-col cols="3"></v-col>
                                <v-col cols="2">
                                    <v-text-field
                                            v-model="model.tak_limit_tonaje"
                                            id="tak_limit_tonaje"
                                            suffix="تن"
                                            outlined
                                            dense
                                            :disabled="!model.tonaje_limit"

                                            @keypress="isNumber"
                                            v-on:keyup.enter="another_focus('joft_limit_tonaje')"
                                            label="تعداد محور تک"/>
                                </v-col>
                                <v-col cols="2">
                                    <v-text-field
                                            v-model="model.joft_limit_tonaje"
                                            id="joft_limit_tonaje"
                                            dense
                                            :disabled="!model.tonaje_limit"

                                            suffix="تن"
                                            outlined
                                            @keypress="isNumber"
                                            v-on:keyup.enter="another_focus('doc_date')"
                                            label="تعداد محور جفت"/>
                                </v-col>
                                <v-col cols="2">
                                    <v-checkbox
                                            id="tonaje_limit"
                                            label="سقف حمل تناژ محاسبه شود"
                                            :value.sync="model.tonaje_limit"
                                            v-model="model.tonaje_limit"
                                    />
                                </v-col>

                            </v-row>

                            <v-row>
                                <v-col cols="2">
                                    <v-row form class="form-group">
                                        <label>
                                            نوع جنس
                                        </label>
                                        <div dir="rtl">
                                            <treeselect
                                                    :matchKeys="['code']"

                                                    v-model="model.selected_load_type"
                                                    :cacheOptions="false"
                                                    :options="load_types"
                                                    id="load_type"
                                                    @select="another_focus_inside('origin_load')"
                                                    placeholder="جستجو نوع جنس"
                                                    :normalizer="normalizer_load_type"
                                            />
                                        </div>
                                    </v-row>
                                </v-col>

                                <v-col cols="2">
                                    <v-row form class="form-group">
                                        <label>
                                            مبدا بارگیری
                                        </label>
                                        <div dir="rtl">
                                            <treeselect
                                                    :matchKeys="['code']"
                                                    v-model="model.selected_origin_load"
                                                    :cacheOptions="false"
                                                    id="origin_load"
                                                    @select="another_focus_inside('discharge_place')"
                                                    :options="origin_loads"
                                                    placeholder="جستجو مبدا بارگیری"
                                                    :normalizer="normalizer_origin"
                                            />
                                        </div>
                                    </v-row>

                                </v-col>

                                <v-col cols="2">
                                    <v-row form class="form-group">
                                        <label>
                                            محل تخلیه
                                        </label>
                                        <div dir="rtl">
                                            <treeselect
                                                    :matchKeys="['code']"
                                                    v-model="model.selected_discharge_place"
                                                    :cacheOptions="false"
                                                    id="discharge_place"
                                                    @select="another_focus('tonaje')"
                                                    :options="discharge_places"
                                                    placeholder="جستجو محل تخلیه"
                                                    :normalizer="normalizer_discharge_place"
                                            />
                                        </div>
                                    </v-row>


                                </v-col>
                                <v-col cols="1">
                                    <v-text-field
                                            v-model="model.tonaje_decimal"
                                            @keypress="isNumber"
                                            dense
                                            outlined
                                            maxlength="3"
                                            label="کیلوگرم"
                                            id="tonaje_decimal"
                                            v-on:keyup.enter="another_focus('insert_row_data')"
                                    />
                                </v-col>
                                <h3 style="align-self: center">
                                    /
                                </h3>
                                <v-col cols="1">

                                    <v-text-field
                                            v-model="model.tonaje"
                                            @keypress="isNumber"
                                            dense
                                            outlined
                                            maxlength="2"
                                            id="tonaje"
                                            v-on:keyup.enter="another_focus('tonaje_decimal')"
                                            label="تناژ"/>
                                </v-col>
                                <v-col>
                                    <v-btn v-if="status_form_row==0" id="insert_row_data" color="success"
                                           @click="insert_row_data()">
                                        تایید
                                    </v-btn>
                                    <v-btn v-if="status_form_row!=0" id="insert_row_data" color="warning"
                                           @click="insert_row_data()">
                                        ویرایش
                                    </v-btn>
                                    <v-btn v-if="status_form_row!=0" color="error" @click="cancel_edit()">
                                        انصراف
                                    </v-btn>
                                </v-col>


                            </v-row>

                            <hr>
                            <v-row>

                                <v-col cols="3">
                                    <v-row>
                                        <v-col cols="7" style="padding: 0px">
                                            <v-subheader>نرخ حمل کارفرما</v-subheader>
                                        </v-col>
                                        <v-col cols="5" style="padding: 0px">
                                            <v-text-field
                                                    label=""
                                                    dense
                                                    disabled
                                                    v-model="calculate_employer"
                                                    suffix="ریال"
                                            ></v-text-field>
                                        </v-col>
                                    </v-row>

                                </v-col>
                                <v-col cols="3">
                                    <v-row>
                                        <v-col cols="7" style="padding: 0px">
                                            <v-subheader>نرخ حمل مورد محاسبه کارفرما</v-subheader>
                                        </v-col>
                                        <v-col cols="5" style="padding: 0px">
                                            <v-text-field
                                                    disabled
                                                    label=""
                                                    dense
                                                    v-model="deliver_employer"
                                                    suffix="ریال"
                                            ></v-text-field>
                                        </v-col>
                                    </v-row>

                                </v-col>
                                <v-col cols="3">
                                    <v-row>
                                        <v-col cols="7" style="padding: 0px">
                                            <v-subheader>نرخ حمل کامیوندار</v-subheader>
                                        </v-col>
                                        <v-col cols="5" style="padding: 0px">
                                            <v-text-field
                                                    label=""
                                                    dense
                                                    disabled
                                                    v-model="paying_driver"
                                                    suffix="ریال"
                                            ></v-text-field>
                                        </v-col>
                                    </v-row>

                                </v-col>
                                <v-col cols="3">
                                    <v-row>
                                        <v-col cols="7" style="padding: 0px">
                                            <v-subheader>نرخ حمل مورد محاسبه کامیوندار</v-subheader>
                                        </v-col>
                                        <v-col cols="5" style="padding: 0px">
                                            <v-text-field
                                                    label=""
                                                    dense
                                                    disabled
                                                    v-model="real_paying_driver"
                                                    suffix="ریال"
                                            ></v-text-field>
                                        </v-col>
                                    </v-row>

                                </v-col>
                            </v-row>

                            <hr>
                            <div class="row ">
                                <VDataTable2
                                        v-show="false"
                                        dense
                                        multi-sort
                                        height="400"
                                        fixed-header
                                        hide-default-footer
                                        disable-pagination
                                        class="margin-auto table-bordered"
                                        :headers="headers"
                                        :items-per-page="1000"
                                        :items="items"
                                >
                                    <template v-slot:item.row_id="{item }">
                                        {{ item._row_index+1}}
                                    </template>
                                    <template v-slot:item.driver_price="{ item }">
                                        {{ get_currency(calculate_driver_price(item)) }}
                                    </template>
                                    <template v-slot:item.barname="{  }">
                                        {{ model.tozin_number }}
                                    </template>
                                    <template v-slot:item.date="{  }">
                                        {{ get_date(model.doc_date) }}
                                    </template>
                                    <template v-slot:item.truck="{  }">
                                        {{ trucks.filter(x=>x.id==model.selected_truck)[0].name }}
                                    </template>
                                    <template v-slot:item.employer_price="{ item }">
                                        {{ get_currency(calculate_employer_price(item)) }}
                                    </template>
                                    <template v-slot:item.load_type="{ item }">
                                        <td>{{ load_types.filter(x => x.id == item.selected_load_type)[0].name }}</td>
                                    </template>
                                    <template v-slot:item.origin_load="{ item }">
                                        <td>{{ origin_loads.filter(x => x.id == item.selected_origin_load)[0].name }}
                                        </td>
                                    </template>
                                    <template v-slot:item.discharge_place="{ item }">
                                        <td>{{ discharge_places.filter(x => x.id ==
                                            item.selected_discharge_place)[0].name }}
                                        </td>
                                    </template>

                                    <template v-slot:item.operation="{ item }">

                                        <v-btn title="ویرایش" @click="edit_item(item)" outlined small color="warning">
                                            <v-icon small color="warning">mdi-pencil</v-icon>
                                        </v-btn>
                                        <v-btn title="حذف" @click="delete_item_dialog(item)" outlined small
                                               color="error">
                                            <v-icon small color="error">mdi-delete</v-icon>
                                        </v-btn>
                                    </template>
                                </VDataTable2>
                            </div>
                            <!--                            <v-col cols="3">-->
                            <!--                                <v-btn v-if="status_form==0" color="success" id="add_delivery_document"-->
                            <!--                                       @click="insert_data()">-->
                            <!--                                    ثبت-->
                            <!--                                </v-btn>-->
                            <!--                                <v-btn v-if="status_form!=0" color="warning" id="add_delivery_document"-->
                            <!--                                       @click="insert_data()">-->
                            <!--                                    ویرایش-->
                            <!--                                </v-btn>-->
                            <!--                                <v-btn color="warning" @click="reset_form()">انصراف</v-btn>-->
                            <!--                            </v-col>-->
                        </v-card-text>
                    </form>
                    <hr>


                </v-card>
            </v-col>
        </v-row>
        <v-card>
            <v-row style="text-align: right;">
                <v-col>
                    بارگزاری فایل اکسل
                </v-col>

                <v-col>
                    <input type="file" @change="onFileChange">

                </v-col>
                <v-col>
                    <v-btn color="primary" @click="upload_excel">بارگزاری فایل</v-btn>

                </v-col>
            </v-row>
        </v-card>
        <v-dialog
                transition="dialog-bottom-transition"
                max-width="600"
                v-model="docInfoModal"
        >
            <template v-slot:default="dialog">
                <v-card>
                    <v-toolbar
                            color="error"
                            dark
                            :dense="dialog"

                    >نمایش سند
                    </v-toolbar>
                    <v-card-subtitle class="text-right">
                        <v-row>
                            <v-col cols="3">شماره بارنامه: {{selected_factor.barname}}</v-col>
                            <v-col cols="3">تاریخ سند: {{selected_factor.doc_date_persian}}</v-col>
                            <v-col cols="3">نام کامیون: {{selected_factor.truck_name}}</v-col>
                            <v-col cols="3">تناژ: {{selected_factor.items[0].real_tonaje}}</v-col>

                        </v-row>
                    </v-card-subtitle>
                    <v-card-actions class="justify-end">
                        <v-btn
                                text
                                @click="docInfoModal = false"
                        >بستن
                        </v-btn>
                        <v-btn
                                text
                                @click="$router.push({path:'/edit-delivery-document/'+selected_factor.id})"
                        >ویرایش سند
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </template>
        </v-dialog>

    </div>
</template>
<script>
    import Vue from 'vue'
    import {bus} from '../../main'
    import Treeselect from '@riophae/vue-treeselect'
    // import the styles
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import VuePersianDatetimePicker from 'vue-persian-datetime-picker'

    export default {
        name: 'OriginDownload',
        components: {
            Treeselect,
            datePicker: VuePersianDatetimePicker
        },
        data() {
            return {
                confirm_delete_name: 'confirm_delete' + new Date().getTime() + '_' + this.$vnode.tag,
                items: [],
                status_form: 0,
                status_form_row: 0,
                origin_loads: [],
                discharge_places: [],
                load_types: [],
                trucks: [],
                docInfoModal: false,
                final_tonaje_c: 0,
                selected_factor: {},
                model: {
                    selected_truck: null,
                    selected_origin_load: null,
                    selected_discharge_place: null,
                    selected_load_type: null,
                    buy_price: '',
                    buy_tax: '',
                    delivery_price: '',
                    delivery_tax: '',
                    doc_date: '',
                    tak_limit_tonaje: '20',
                    joft_limit_tonaje: '22',
                    row_number: '1',
                    tonaje: '',
                    tonaje_decimal: '',
                    tozin_number: '',
                    tonaje_limit: false,
                },
                date_day: '',
                accounting_year: '',
                date_month: '',
                date_year: '',
                barname_description: '',
                barname_exist: false,
                headers: [
                    {
                        text: 'ردیف',
                        value: 'index'
                    }, {
                        text: 'شماره بارنامه',
                        value: 'barname'
                    }, {
                        text: 'تاریخ',
                        value: 'date'
                    }, {
                        text: 'کامیون',
                        value: 'truck'
                    },
                    {
                        text: 'تناژ',
                        value: 'tonaje'
                    },
                    {
                        text: 'نوع جنس',
                        value: 'load_type'
                    },
                    {
                        text: 'مبدا بارگیری',
                        value: 'origin_load'
                    },
                    {
                        text: 'محل تخلیه',
                        value: 'discharge_place'
                    },

                    {
                        text: 'مبلغ کارفرما',
                        value: 'employer_price'
                    },
                    {
                        text: 'مبلغ راننده',
                        value: 'driver_price'
                    },
                    {
                        text: 'عملیات',
                        value: 'operation'
                    }
                ],
                factor_excel: null,
                normalizer_origin(node) {
                    return {
                        id: node.id,
                        label: node.code + ' - ' + node.name,
                        code: node.code,

                    }
                },
                normalizer_load_type(node) {
                    return {
                        id: node.id,
                        label: node.code + ' - ' + node.name,
                        code: node.code,

                    }
                },
                normalizer_discharge_place(node) {
                    return {
                        id: node.id,
                        label: node.code + ' - ' + node.name,
                        code: node.code,

                    }
                },
                normalizer_truck(node) {
                    return {
                        id: node.id,
                        label: node.code + ' - ' + node.name,
                        code: node.code,

                    }
                },
            }
        },
        mounted() {
            this.another_focus('barname');
            if (localStorage.getItem("insert_delivery_doc_date") == null) {
                this.model.doc_date = this.get_today()
                this.date_year = this.get_today_array()[0]
                this.date_month = this.get_today_array()[1]
                this.date_day = this.get_today_array()[2]

            } else {
                this.model.doc_date = localStorage.getItem("insert_delivery_doc_date")
                console.log("doc date", this.model.doc_date)
                this.date_year = this.model.doc_date.split("/")[0]
                this.date_month = this.model.doc_date.split("/")[1]
                this.date_day = this.model.doc_date.split("/")[2]

            }
            this.get_trucks()
            this.get_settings()

            bus.$on(this.confirm_delete_name, (data) => {
                // alert(data);
                if (data == 'true') {
                    this.delete_item()

                } else {
                    this.status_form = 0
                }
            })
        },
        watch: {
            'model.doc_date': function () {
                localStorage.setItem("insert_delivery_doc_date", this.model.doc_date);
            },
            'date_day': function () {
                console.log("date_day changed", this.date_day)
                this.model.doc_date = this.date_year + "/" + this.date_month + "/" + this.date_day
                localStorage.setItem("insert_delivery_doc_date", this.model.doc_date);
            },
            'date_month': function () {
                console.log("date_month changed", this.date_month)

                this.model.doc_date = this.date_year + "/" + this.date_month + "/" + this.date_day
                localStorage.setItem("insert_delivery_doc_date", this.model.doc_date);
            },
            'date_year': function () {
                console.log("date_year changed", this.date_year)

                this.model.doc_date = this.date_year + "/" + this.date_month + "/" + this.date_day
                localStorage.setItem("insert_delivery_doc_date", this.model.doc_date);
            },
            'model.tozin_number': function () {
                this.get_barname_info()
            },
            '$route.params.doc_id': function () {
                location.reload()
            }
        },
        computed: {
            calculate_employer() {
                if (this.model.selected_discharge_place == null || this.model.tonaje == '') {
                    return 0
                }
                var ton_dec = 0;
                if (this.model.tonaje_decimal != "") {
                    ton_dec = this.model.tonaje_decimal;
                }

                var price = 0

                // if (this.status_form != 0) {
                //   price = this.model.employer_price
                //
                // } else {
                price = this.discharge_places.filter(x => x.id == this.model.selected_discharge_place)[0].employer_price

                var tonaje = parseFloat(this.model.tonaje + "." + ton_dec)
                return this.get_currency(parseFloat(parseFloat(price) * tonaje).toFixed(0))

            },
            deliver_employer() {
                if (this.model.selected_discharge_place == null || this.model.tonaje == '') {
                    return 0
                }
                var ton_dec = 0;
                if (this.model.tonaje_decimal != "") {
                    ton_dec = this.model.tonaje_decimal;
                }
                var price = 0

                // if (this.status_form != 0) {
                //   price = this.model.employer_price
                //
                // } else {
                price = this.discharge_places.filter(x => x.id == this.model.selected_discharge_place)[0].employer_price
                // }
                var tonaje = parseFloat(this.model.tonaje + "." + ton_dec)

                var truck = this.trucks.filter(x => x.id == this.model.selected_truck)[0]
                if (this.model.tonaje_limit) {
                    if (truck.type == 1 && tonaje > this.model.tak_limit_tonaje) {
                        tonaje = this.model.tak_limit_tonaje
                    }
                    if (truck.type == 2 && tonaje > this.model.joft_limit_tonaje) {
                        tonaje = this.model.joft_limit_tonaje
                    }
                }
                return this.get_currency(parseFloat(parseFloat(price) * tonaje).toFixed(0))

            },
            paying_driver() {
                if (this.model.selected_discharge_place == null || this.model.tonaje == '') {
                    return 0
                }
                var ton_dec = 0;
                if (this.model.tonaje_decimal != "") {
                    ton_dec = this.model.tonaje_decimal;
                }
                var price = 0

                // if (this.status_form != 0) {
                //   price = this.model.driver_price
                // } else {
                price = this.discharge_places.filter(x => x.id == this.model.selected_discharge_place)[0].driver_price
                // }
                var tonaje = parseFloat(this.model.tonaje + "." + ton_dec)
                return this.get_currency(parseFloat(parseFloat(price) * tonaje).toFixed(0))

            },
            real_paying_driver() {
                if (this.model.selected_discharge_place == null || this.model.tonaje == '' || this.model.selected_truck == null) {
                    return 0
                }
                var ton_dec = 0;
                if (this.model.tonaje_decimal != "") {
                    ton_dec = this.model.tonaje_decimal;
                }
                var price = 0
                // if (this.status_form != 0) {
                //   price = this.model.driver_price
                // } else {
                price = this.discharge_places.filter(x => x.id == this.model.selected_discharge_place)[0].driver_price
                // }
                var truck = this.trucks.filter(x => x.id == this.model.selected_truck)[0]
                var tonaje = parseFloat(this.model.tonaje + "." + ton_dec)
                if (this.model.tonaje_limit) {
                    if (truck.type == 1 && tonaje > this.model.tak_limit_tonaje) {
                        tonaje = this.model.tak_limit_tonaje
                    }
                    if (truck.type == 2 && tonaje > this.model.joft_limit_tonaje) {
                        tonaje = this.model.joft_limit_tonaje
                    }
                }
                return this.get_currency(parseFloat(parseFloat(price) * tonaje).toFixed(0))
            },
        },
        methods: {
            barname_next_focus() {
                if (this.barname_exist) {
                    this.another_focus_select('info_exist_barname')
                } else {
                    this.another_focus_select('date_day')

                }
            },
            calculate_employer_price(item) {
                if (item.selected_discharge_place == null || item.tonaje == '') {
                    return 0
                }
                var price = 0

                price = this.discharge_places.filter(x => x.id == item.selected_discharge_place)[0].employer_price

                var truck = this.trucks.filter(x => x.id == this.model.selected_truck)[0]
                var tonaje = parseFloat(item.tonaje + "." + item.tonaje_decimal)
                if (item.tonaje_limit) {
                    if (truck.type == 1 && tonaje > item.tak_limit_tonaje) {
                        tonaje = item.tak_limit_tonaje
                    }
                    if (truck.type == 2 && tonaje > item.joft_limit_tonaje) {
                        tonaje = item.joft_limit_tonaje
                    }
                }
                return (parseFloat(parseFloat(price) * tonaje).toFixed(0))

            },
            calculate_driver_price(item) {
                if (item.selected_discharge_place == null || item.tonaje == '') {
                    return 0
                }
                var price = 0

                price = this.discharge_places.filter(x => x.id == item.selected_discharge_place)[0].driver_price

                var truck = this.trucks.filter(x => x.id == this.model.selected_truck)[0]
                var tonaje = parseFloat(item.tonaje + "." + item.tonaje_decimal)
                if (item.tonaje_limit) {
                    if (truck.type == 1 && tonaje > item.tak_limit_tonaje) {
                        tonaje = item.tak_limit_tonaje
                    }
                    if (truck.type == 2 && tonaje > item.joft_limit_tonaje) {
                        tonaje = item.joft_limit_tonaje
                    }
                }
                return (parseFloat(parseFloat(price) * tonaje).toFixed(0))
            },
            get_settings() {
                var self = this
                const formData = new FormData()
                // formData.append('id', this.selected_province);
                this.axios.post('/api/settings/select', formData, {}).then(function (response) {

                    // items = content_cats.orders;
                    if (response.data.error == 0) {

                        var item = response.data.data
                        item.forEach(function (val) {
                            if (val.code == 'tonaje_limit') {
                                if (val.value == 1) {
                                    self.model.tonaje_limit = true
                                } else {
                                    self.model.tonaje_limit = false
                                }
                            }
                            if (val.code == 'tak_tonaje_limit') {
                                self.model.tak_limit_tonaje = val.value
                            }
                            if (val.code == 'joft_tonaje_limit') {
                                self.model.joft_limit_tonaje = val.value
                            }
                            if (val.code == 'accounting_year') {
                                self.accounting_year = val.value
                                self.date_year = val.value
                            }
                        })
                    } else {
                        self.$root.modal_component.show_danger_modal('خطا', response.data.msg)

                    }

                }).catch(function (error) {
                    self.$root.modal_component.show_danger_modal('خطا در ثبت', 'لطفا تمامی موارد را چک کنید')

                    console.log(error)
                })

            },

            reset_form() {
                if (this.status_form != 1) {
                    this.$router.go(-1)
                }
                this.model = {
                    selected_truck: null,
                    selected_origin_load: null,
                    selected_discharge_place: null,
                    selected_load_type: null,
                    buy_price: '',
                    buy_tax: '',
                    delivery_price: '',
                    delivery_tax: '',
                    row_number: '1',
                    tonaje: '',
                    tonaje_decimal: "",
                }
                this.status_form = 0
            },

            get_data() {
                var self = this
                const formData = new FormData()
                formData.append('id', this.status_form)
                this.axios.post('/api/delivery_document/select_one', formData, {}).then(function (response) {

                    // items = content_cats.orders;
                    if (response.data.error == 0) {
                        var item = response.data.data

                        var row_index = 0
                        item.items.forEach((val) => {
                            val.selected_origin_load = parseInt(val.origin_load_id)
                            val.selected_load_type = parseInt(val.load_type_id)
                            val.selected_discharge_place = parseInt(val.discharge_id)
                            if (parseInt(val.tonaje_limit) == 1) {
                                val.tonaje_limit = true
                            } else {
                                val.tonaje_limit = false
                            }
                            row_index += 1
                            val.index = row_index

                        })
                        self.items = item.items;
                        console.log(self.items)

                        // item.tonaje = parseFloat(item.tonaje).toFixed(3)
                        //
                        // self.model = item
                        //
                        // self.model.tonaje = parseInt(self.model.tonaje)
                        //

                        self.edit_item(self.items[0])

                        self.model.selected_truck = parseInt(item.truck_id)
                        self.model.tozin_number = item.barname
                        self.date_day = item.doc_date_persian.split('/')[2]
                        self.date_month = item.doc_date_persian.split('/')[1]
                        self.date_year = item.doc_date_persian.split('/')[0]
                    } else {
                        self.$root.modal_component.show_danger_modal('خطا', response.data.msg)

                    }

                }).catch(function (error) {
                    self.$root.modal_component.show_danger_modal('خطا در ثبت', 'لطفا تمامی موارد را چک کنید')

                    console.log(error)
                })

            },
            get_barname_info() {
                var self = this
                const formData = new FormData()
                formData.append('barname', this.model.tozin_number)
                this.axios.post('/api/delivery_document/get_barname_info', formData, {show_pros: false}).then(function (response) {
                    self.barname_description = ""
                    self.barname_exist = false

                    // items = content_cats.orders;
                    if (response.data.error == 1) {
                        if (self.status_form != 0 && response.data.data.id != self.status_form) {
                            self.barname_description = "بارنامه تکراری می باشد"
                            self.barname_exist = true
                            self.selected_factor = response.data.data;

                        } else if (self.status_form == 0) {
                            self.barname_description = "بارنامه تکراری می باشد"
                            self.barname_exist = true
                            self.selected_factor = response.data.data;


                        }
                    }


                }).catch(function (error) {
                    self.$root.modal_component.show_danger_modal('خطا در ثبت', 'لطفا تمامی موارد را چک کنید')

                    console.log(error)
                })

            },
            insert_data() {

                if (this.model.selected_truck == null) {
                    this.$root.modal_component.show_warning_notif('کامیون را انتخاب کنید')
                    return
                }
                if (this.jalali_to_miladi(this.model.doc_date) == "Invalid date") {
                    this.$root.modal_component.show_warning_notif('تاریخ سند اشتباه است')
                    return
                }
                console.log(this.jalali_to_miladi(this.model.doc_date))
                // if (this.items.length == 0) {
                //     this.$root.modal_component.show_warning_notif('بک با چند ردیف اضافه کنید')
                //     return
                // }
                if (this.model.tozin_number == '') {
                    this.$root.modal_component.show_warning_notif('شماره بارنامه را وارد کنید')
                    return
                }

                var self = this
                const formData = new FormData()
                // formData.append('id', this.selected_province);
                var url = '/api/delivery_document/insert'
                if (this.status_form != 0) {
                    url = '/api/delivery_document/update'
                    formData.append('id', this.status_form)
                }
                formData.append('doc_date', this.jalali_to_miladi(this.model.doc_date))
                formData.append('truck_id', this.model.selected_truck)
                formData.append('barname', this.model.tozin_number)
                var new_model = JSON.parse(JSON.stringify(this.model))
                new_model.tonaje = this.final_tonaje_c
                formData.append('items', JSON.stringify([new_model]))

                // formData.append('origin_load_id', this.model.selected_origin_load)
                // formData.append('discharge_place_id', this.model.selected_discharge_place)
                // formData.append('load_type_id', this.model.selected_load_type)
                // formData.append('tonaje', this.model.tonaje)
                // formData.append('tak_limit_tonaje', this.model.tak_limit_tonaje)
                // formData.append('joft_limit_tonaje', this.model.joft_limit_tonaje)
                // formData.append('row_number', this.model.row_number)
                // formData.append('tozin_number', this.model.tozin_number)
                // if (this.model.tonaje_limit) {
                //   formData.append('tonaje_limit', 1)
                // } else {
                //   formData.append('tonaje_limit', 0)
                // }

                this.axios.post(url, formData, {}).then(function (response) {
                    self.$root.modal_component.show_api_response_modals(response)

                    // items = content_cats.orders;
                    if (response.data.error == 0) {
                        // self.reset_form()
                        // self.get_data()
                        if (self.$route.params.doc_id != null) {
                            self.$router.push({path: '/insert-delivery-document'})

                        }else{
                            location.reload();
                        }
                    }
                }).catch(function (error) {
                    self.$root.modal_component.show_danger_modal('خطا در ثبت', 'لطفا تمامی موارد را چک کنید')

                    console.log(error)
                })

            },
            insert_row_data() {
                if (this.model.selected_truck == null) {
                    this.$root.modal_component.show_warning_notif('کامیون را انتخاب کنید')
                    return
                }
                if (this.model.tak_limit_tonaje == '' || this.model.joft_limit_tonaje == '') {
                    this.$root.modal_component.show_warning_notif('سقف تناژ را وارد کنید')
                    return
                }

                if (this.model.selected_load_type == null) {
                    this.$root.modal_component.show_warning_notif('نوع جنس را انتخاب کنید')
                    return
                }
                if (this.model.tonaje == '' && this.model.tonaje_decimal == "") {
                    this.$root.modal_component.show_warning_notif('تناژ را وارد کنید')
                    return
                }
                if (this.model.selected_origin_load == null) {
                    this.$root.modal_component.show_warning_notif('مبدا بارگیری را انتخاب کنید')
                    return
                }
                if (this.model.selected_discharge_place == null) {
                    this.$root.modal_component.show_warning_notif('محل تخلیه را انتخاب کنید')
                    return
                }
                var employer_price = this.discharge_places.filter(x => x.id == this.model.selected_discharge_place)[0].employer_price
                var driver_price = this.discharge_places.filter(x => x.id == this.model.selected_discharge_place)[0].driver_price
                this.model.employer_price = employer_price
                this.model.driver_price = driver_price
                this.final_tonaje_c = parseFloat(this.model.tonaje + "." + this.model.tonaje_decimal)
                var truck = this.trucks.filter(x => x.id == this.model.selected_truck)[0]
                this.model.real_tonaje = this.final_tonaje_c
                if (this.model.tonaje_limit) {
                    if (truck.type == 1 && this.final_tonaje_c > this.model.tak_limit_tonaje) {
                        this.model.real_tonaje = this.model.tak_limit_tonaje
                    }
                    if (truck.type == 2 && this.final_tonaje_c > this.model.joft_limit_tonaje) {
                        this.model.real_tonaje = this.model.joft_limit_tonaje
                    }
                }
                this.model.real_driver_price = this.calculate_driver_price(this.model);
                this.model.real_employer_price = this.calculate_employer_price(this.model);
                this.model.summary = "حمل  " + this.load_types.filter(x => x.id == this.model.selected_load_type)[0].name + " " + this.final_tonaje_c + " تن از " + this.origin_loads.filter(x => x.id == this.model.selected_origin_load)[0].name + " به " + this.discharge_places.filter(x => x.id == this.model.selected_discharge_place)[0].name;
                console.log("before insert driver", this.model)

                if (this.status_form_row != 0) {
                    this.update_item()
                    return
                }

                // formData.append('driver_price', driver_price)

                // this.items.push(JSON.parse(JSON.stringify(this.model)))
                // this.model.selected_origin_load = null
                // this.model.selected_discharge_place = null
                // this.model.selected_load_type = null
                // this.model.delivery_price = ''
                // this.model.delivery_tax = ''
                // this.model.tonaje = ''
                // this.model.tonaje_decimal = ''
                // this.status_form_row = 0

                // var row_index = 0
                // this.items.forEach((val) => {
                //     row_index += 1
                //
                //     val.index = row_index
                //
                // })

                this.insert_data();
            },
            update_item() {
                console.log("update called", this.status_form_row)
                Vue.set(this.items, this.status_form_row - 1, (JSON.parse(JSON.stringify(this.model))))
                // this.items[this.status_form_row]=(JSON.parse(JSON.stringify(this.model)))
                // this.model.selected_origin_load = null
                // this.model.selected_discharge_place = null
                // this.model.selected_load_type = null
                // this.model.delivery_price = ''
                // this.model.delivery_tax = ''
                // this.model.tonaje = ''
                // this.model.tonaje_decimal = ''
                // this.status_form_row = 0
                //
                // var row_index = 0
                //
                // this.items.forEach((val) => {
                //     row_index += 1
                //     val.index = row_index
                //
                // })
                this.insert_data()
            },
            cancel_edit() {
                this.model.selected_origin_load = null
                this.model.selected_discharge_place = null
                this.model.selected_load_type = null
                this.model.delivery_price = ''
                this.model.delivery_tax = ''
                this.model.tonaje = ''
                this.status_form_row = 0

                var row_index = 0
                this.items.forEach((val) => {
                    row_index += 1

                    val.index = row_index

                })
                this.$router.go(-1)
            },
            edit_item(item) {
                this.model.selected_origin_load = item.selected_origin_load
                this.model.selected_discharge_place = item.selected_discharge_place
                this.model.selected_load_type = item.selected_load_type
                this.model.delivery_price = item.delivery_price
                this.model.delivery_tax = item.delivery_tax
                console.log("tonaje is ", item.tonaje)
                // this.model.tonaje_decimal = this.getDecimalPart(parseFloat(item.tonaje));
                this.model.tonaje_decimal = item.tonaje.substring(item.tonaje.indexOf('.') + 1);
// console.log('tonaje decimal is',item.tonaje.substring(item.tonaje.indexOf('.')+1))
                this.model.tonaje = parseInt(item.tonaje)
                // this.model.tozin_number = item.barname
                this.model.employer_price = item.employer_price
                this.model.driver_price = item.driver_price
                this.status_form_row = item.index

            },
            getDecimalPart(num) {
                if (Number.isInteger(num)) {
                    return '';
                }

                const decimalStr = num.toString().split('.')[1];
                return Number(decimalStr);
            },
            get_trucks() {
                var self = this
                const formData = new FormData()
                // formData.append('id', this.selected_province);
                this.axios.post('/api/trucks/select', formData, {}).then(function (response) {

                    // items = content_cats.orders;
                    if (response.data.error == 0) {

                        self.trucks = response.data.data
                        self.trucks.sort((a, b) => a.code.localeCompare(b.code, undefined, {numeric: true, sensitivity: 'base'}));


                    } else {
                        self.$root.modal_component.show_danger_modal('خطا', response.data.msg)

                    }
                    self.get_origin_downloads()

                }).catch(function (error) {
                    self.$root.modal_component.show_danger_modal('خطا در ثبت', 'لطفا تمامی موارد را چک کنید')

                    console.log(error)
                })

            },

            get_origin_downloads() {
                var self = this
                const formData = new FormData()
                // formData.append('id', this.selected_province);
                this.axios.post('/api/origin/select', formData, {}).then(function (response) {

                    // items = content_cats.orders;
                    if (response.data.error == 0) {

                        self.origin_loads = response.data.data
                      self.origin_loads.sort((a, b) => a.code.localeCompare(b.code, undefined, {numeric: true, sensitivity: 'base'}));

                    } else {
                        self.$root.modal_component.show_danger_modal('خطا', response.data.msg)

                    }
                    self.get_load_types()
                }).catch(function (error) {
                    self.$root.modal_component.show_danger_modal('خطا در ثبت', 'لطفا تمامی موارد را چک کنید')

                    console.log(error)
                })

            },
            get_load_types() {
                var self = this
                const formData = new FormData()
                // formData.append('id', this.selected_province);
                this.axios.post('/api/load_type/select', formData, {}).then(function (response) {

                    // items = content_cats.orders;
                    if (response.data.error == 0) {

                        self.load_types = response.data.data

                    } else {
                        self.$root.modal_component.show_danger_modal('خطا', response.data.msg)

                    }
                    self.get_discharge_places()

                }).catch(function (error) {
                    console.log(error)
                })

            },
            get_discharge_places() {
                var self = this
                const formData = new FormData()
                // formData.append('id', this.selected_province);
                this.axios.post('/api/discharge_places/select', formData, {}).then(function (response) {

                    // items = content_cats.orders;
                    if (response.data.error == 0) {

                        self.discharge_places = response.data.data

                    } else {
                        self.$root.modal_component.show_danger_modal('خطا', response.data.msg)

                    }
                    if (self.$route.params.doc_id != null) {
                        self.status_form = self.$route.params.doc_id
                        self.get_data()
                    }
                }).catch(function (error) {
                    self.$root.modal_component.show_danger_modal('خطا در ثبت', 'لطفا تمامی موارد را چک کنید')

                    console.log(error)
                })

            },
            delete_item_dialog(item) {
                this.$root.modal_component.show_confirm_modal('هشدار', 'آیا مایل به حذف این ردیف هستید؟', ['تایید'], this.confirm_delete_name)
                this.status_form_row = item.index

            },
            delete_item() {
                this.items.splice(this.status_form_row, 1)
                this.status_form_row = 0
                this.model.selected_origin_load = null
                this.model.selected_discharge_place = null
                this.model.selected_load_type = null
                this.model.delivery_price = ''
                this.model.delivery_tax = ''
                this.model.tonaje = ''
                var row_index = 0
                this.items.forEach((val) => {
                    row_index += 1

                    val.index = row_index

                })
            },
            onFileChange(e) {
                const file = e.target.files[0];
                // this.user_img = e.target.files[0];
                this.factor_excel = e.target.files[0];

            },
            upload_excel() {
                var self = this;
                let formData = new FormData();

                if (self.factor_excel != null) {
                    formData.append("image", self.factor_excel)
                } else {
                    return
                }
                let config = {
                    header: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
                this.axios.post('/api/upload_excel', formData, config)
                    .then(function (response) {
                        var error = "";
                        response.data.forEach(function (val) {
                            error += "\n" + val;
                        })
                        alert(error)
                        // self.alert = true;
                    })
                    .catch(function (error) {
                        // handle error
                        console.log(error);
                    })
            },


        }
    }
</script>
<style>
    #insert_row_data:focus {
        border: 1px solid #000ff6 !important;
        background: #2b9dff !important;
    }
</style>
